var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVestidor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 85,
    viewBox: "0 0 85 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "t-shirt-24-outlined"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.8097 6.57874L79.9211 19.0917L77.5803 42.5H67.2918V77.9167H17.7084V42.5H7.41993L5.0791 19.0917L32.1905 6.57874L33.8397 7.67816C36.8251 9.66847 39.6947 10.625 42.5001 10.625C45.0249 10.625 47.6018 9.85021 50.2683 8.24432L51.1605 7.67816L52.8097 6.57874ZM25.9962 17.2321L12.6297 23.4033L13.8303 35.4167H24.7918V70.8333H60.2084V35.4167H71.1663L72.367 23.4033L58.9974 17.2356L58.9071 17.4036L57.5932 19.9553C54.4756 25.9307 50.8061 28.3333 42.5001 28.3333C34.5017 28.3333 30.8028 26.1054 27.7559 20.6046L26.0931 17.4036L25.9962 17.2321ZM33.687 16.6788L33.0132 15.3749C36.125 16.9197 39.2945 17.7083 42.5001 17.7083C45.7045 17.7083 48.8728 16.9203 51.9834 15.3766L51.4363 16.4403L51.0524 17.1678C49.2475 20.4695 47.8139 21.25 42.5001 21.25L41.7669 21.2445C36.813 21.1662 35.5369 20.2246 33.687 16.6788Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVestidor);
export default __webpack_public_path__ + "static/media/vestidor.48ec0d17074839c324dd81c4b0d248fc.svg";
export { ForwardRef as ReactComponent };